<template>
    <div>
        <template v-if="field !== undefined">
            <template v-if="field.formatter !== undefined">
                {{ field.formatter.apply(null, [fieldValue(field), field.key, item])  }}
            </template>

            <ImageField v-else-if="field.module == 'input' && field.type == 'image'" :value="fieldValue(field)" />

            <RelationField v-else-if="field.module == 'select' && field.type == 'relation'" :value="item" :field="field" :i18nLabel="i18nLabel" v-once/>

            <template v-else-if="field.module == 'picker' && field.type == 'daterange'">
                 {{ dateRangeLabel(fieldValue(field)) }}
            </template>

            <template v-else-if="field.module == 'picker' && field.type == 'date'">
                {{ dateLabel(fieldValue(field)) }}
            </template>

             <template v-else-if="field.module == 'checkbox' && field.type == 'bool'">
                 <span v-if="fieldValue(field)" class="checkboxBool">  </span>
                 <span v-else class="checkboxBool no">  </span>
            </template>

            <template v-else-if="field.module == 'image' && field.type == 'carousel'">
                <ImageCarousel :value="fieldValue(field)" />
            </template>

            <template v-else-if="field.module == 'fieldset' && field.type == 'default'">
                <span v-if="fieldValue(field)">
                    {{ fieldValue(field).length }}
                </span>
                <span v-else> 0 </span>
            </template>

            <template v-else-if="field.module == 'select'">
                <div v-if="field.type == 'text' || field.type == 'number'"> 
                    <div v-if="isSelectFieldArray(fieldValue(field))">
                        <b-badge v-for="c in fieldValue(field)" :key="c" variant="dark" class="p-1 m-1"> {{ c }} </b-badge> 
                    </div>

                    <div v-else>
                        <b-badge v-if="fieldValue(field) !== null" variant="dark" class="p-1 m-1"> {{ fieldValue(field) }} </b-badge> 
                    </div>
                </div>
            </template>

            <template v-else-if="field.module == 'input' && field.type == 'file'">
                 <Files :value="fieldValue(field)" />
            </template>

            <template v-else-if="field.module == 'data' && field.type == 'json'">
                <DataJson :value="fieldValue(field)" />
            </template>

            <template v-else-if="field.module == 'text' && field.type.includes('editor')">
                <TextEditor :value="i18nLabel(fieldValue(field))" :field="field" />
            </template>

            <template v-else-if="field.module == 'text'">
                {{ truncate(i18nLabel(fieldValue(field)), { length: 100, omission: '...' }) }}
            </template>

            <template v-else>
                {{ truncate(i18nLabel(fieldValue(field)), { length: 100, omission: '...' }) }}
            </template>
        </template>

        <template v-else>
            {{ truncate(item, {
                length: 50,
                omission: '...'
            }) }}
        </template>
    </div>
</template>

<style lang="scss">
.checkboxBool {
    padding:7px;
    border-radius:50px;
    background-color:green;
    display: block;
    width: 0px;
    height: 0px;
    margin: 0 auto;

    &.no {
        background-color: red;
    }
}
</style>

<script>
import moment from "moment"
import truncate from "lodash/truncate"
import get from "lodash/get"
import RelationField from "./Relation"

export default {
    components: { 
        ImageField: () => import("./Image.vue"),
        Files: () => import("./Files.vue"),
        ImageCarousel: () => import("./ImageCarousel.vue"),
        DataJson: () => import('./DataJson.vue'),
        TextEditor: () => import('./TextEditor.vue'),
        RelationField
    },
    props: {
        field: {
            type: Object
        },
        itemField: {
            type: String
        },
        item: {
            type: Object
        }
    },

    methods: {
        fieldValue(field) {
            return get(this.item, field.key)
        },

        dateRangeLabel(item) {
            let daterange = this.field.constraints.custom_data.daterange
            let format = "yyyy-mm-dd"
            if (daterange !== undefined) {
                format = daterange.format
            }

            let from =  moment(item.startDate)
            let to =  moment(item.endDate)

            if (from.isValid() && to.isValid())
                return from.format(format.toUpperCase()) + " - " + to.format(format.toUpperCase())
        },

        dateLabel(item) {
            let daterange = this.field.constraints.date.format
            let format = "yyyy-mm-dd"
            if (daterange !== undefined) {
                format = daterange.format
            }

            return moment(item).format(format.toUpperCase())
        },

        i18nLabel(item, field) {
            field = field || this.field
            
            if (item) {
                if (item.locales) {
                    let { custom_data } = field.constraints
                    let { texti18n, i18n } = custom_data
                    let locale = this.$store.getters.getLocale

                    if (texti18n) {
                        locale = texti18n.default_locale || this.$store.getters.getLocale
                    }

                    if (i18n) {
                        locale = i18n.default_locale || this.$store.getters.getLocale
                    }
                
                    return item.locales[locale] || item.locales[this.$store.getters.getLocale]
                    
                }
            }

            return item
        },

        truncate: truncate,

        isSelectFieldArray(value) {
            return Array.isArray(value)
        } 
    },

    created() {
        
    }
}
</script>